// extracted by mini-css-extract-plugin
export default {"variablesDialog":"VariablesDialog-module__variablesDialog--txrtT","DialogOverflowWrapper":"VariablesDialog-module__DialogOverflowWrapper--mtbc2"};